module.exports = __webpack_public_path__ + "img/singola.fa52932b.svg";